import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import type { FC, PropsWithChildren } from 'react';
import { configTypePolicy } from 'services/apollo/ApolloConfig';

export const ApolloClientInstanceProvider: FC<PropsWithChildren<any> & { authToken?: string }> = ({
  authToken,
  children
}) => {
  const httpLink = new HttpLink({
    uri: `${import.meta.env.VITE_REACT_APP_GRAPHQL_HOST}/graphql`,
    headers: { authorization: `Bearer ${authToken}` }
  });
  const wsLink = new GraphQLWsLink(
    createClient({
      url: `${import.meta.env.VITE_REACT_APP_GRAPHQL_WS_HOST}/graphql`,
      connectionParams: { authorization: `Bearer ${authToken}` }
    })
  );

  /**
   * If the operation is a subscription, use the WebSocket link, otherwise use the HTTP link.
   */
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);

      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    httpLink
  );

  const client = new ApolloClient({
    link: splitLink,
    connectToDevTools: true,
    cache: new InMemoryCache({
      typePolicies: {
        EntityType: {
          keyFields: ['packageVersionUuid', 'uuid']
        },
        PackageVersionType: {
          keyFields: ['uuid']
        },
        ConfigSchemas: {
          keyFields: [] as Array<string>
        },
        Query: {
          fields: {
            getAllPackages: configTypePolicy(false, 5),
            getAllPackageVersions: configTypePolicy(['args', ['packageUuid']], 1),
            getEndpointsByPackageVersion: configTypePolicy(['args', ['packageVersionUuid']], 5),
            getModelsByPackageVersion: configTypePolicy(['args', ['packageVersionUuid']], 5),
            getMappingsByPackageVersion: configTypePolicy(['args', ['packageVersionUuid']], 5),
            getFlowsByPackageVersion: configTypePolicy(['args', ['packageVersionUuid', 'flowType']], 5),
            getRuntimeLogs: configTypePolicy(['args', ['packageVersionUuid']], 5)
            // GetConfigSchemas: configTypePolicy([], 5),
            // GetPackageVersionContentInfo: configTypePolicy(['uuid'], 5),
            // GetPackage: configTypePolicy(['uuid'], 5),
            // GetVersion: configTypePolicy(['uuid'], 5),
            // GetPackageContentInfo: configTypePolicy(['uuid'], 5),
            // GetMapping: configTypePolicy(['uuid'], 5),
            // GetFlow: configTypePolicy(['uuid'], 5),
            // GetModel: configTypePolicy(['uuid'], 5),
            // GetEndpoint: configTypePolicy(['uuid'], 5)
          }
        }
      }
    })
  });

  return children({ client });
};
